import * as React from "react";
import { Event } from "../../../../../contracts";
import { renderTeam } from "./renderTeam";
import { renderLeague } from "./renderLeague";

export const renderTeamsWrapper = (event: Event,componentPrefix: string, showLeagueInEventCard: boolean) =>
    <div className={`rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__names`} data-uat={`div-ev-list-${componentPrefix}-names`} >
        {renderLeague(showLeagueInEventCard, event.leagueName)}

        {renderTeam(event, "1", componentPrefix)}
        {renderTeam(event, "2", componentPrefix)}
    </div>